import { API_URL } from "env";
import { VourcherDetailResponse } from "./VourcherType";
import { message } from "antd";

interface VourcherListParams {
    sort: string[];
    name: string;
    limit?: number;
    page?: number;
}

export interface VoucherItem {
    id: number;
    name: string;
    avatar: string | null;
    code: string;
    describe: string;
    is_active: number;
    type: number;
    value: number;
    max_discount: number | null;
    min_amount: number;
    position: number;
    type_customer: number;
    type_voucher: number | null;
    start_date: string;
    exp_date: string;
    max_use_voucher: number;
    max_use_voucher_day: number;
    used_voucher: number;
    customer_usage_limit: number | null;
    created_at: string;
    updated_at: string;
}

export interface VoucherByIdResponse {
    status: boolean;
    data: VoucherItem | null;
    msg: string;
}

async function fetchVourcherList(params?: VourcherListParams): Promise<VourcherDetailResponse> {
    const query = new URLSearchParams();
    if (params) {
        if (params.sort) params.sort.forEach(s => query.append('sort[]', s));
        if (params.name) query.append('name', params.name);
        if (params.limit) query.append('limit', String(params.limit));
        if (params.page) query.append('page', String(params.page));
    }

    const url = `${API_URL}/api/v1/fe/vouchers${query.toString() ? `?${query.toString()}` : ''}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data as VourcherDetailResponse;
    } catch (error) {
        console.error('Failed to fetch vourcher list:', error);
        return {
            data: {
                total: 0,
                current_page: 1,
                items: [],
            },
            status: false,
            msg: 'Failed to fetch vourcher list',
        };
    }

}
async function checkVourcherListProducts(vourcherCode: string, total: number, listProduct: { id: number, product_category_id: number, price: number }[], customer_id: number) {
    try {
        const token = localStorage.getItem('token');
        if (!token) {
            throw new Error('No token found');
        }
        const formData = new FormData();
        formData.append('voucher_code', vourcherCode);
        formData.append('total', total.toString());
        formData.append('customer_id', customer_id.toString());
        formData.append('list_products', JSON.stringify(listProduct));
        const response = await fetch(`${API_URL}/api/v1/fe/order/check_voucher_code`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Failed to fetch vourcher list:', error);
        message.error('Lỗi kiểm tra voucher');
    }
}

async function fetchVoucherDetail(id: number | string): Promise<VoucherByIdResponse> {
    const url = `${API_URL}/api/v1/fe/voucher/${id}`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data as VoucherByIdResponse;
    } catch (error) {
        console.error(`Failed to fetch voucher detail id ${id}:`, error);
        return {
            status: false,
            data: null,
            msg: 'Failed to fetch voucher detail',
        };
    }
}

export {
    fetchVourcherList,
    checkVourcherListProducts,
    fetchVoucherDetail
}